import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import logo from '../../../assets/images/Logo-bodhiwell.png';
import { useFooter } from './hooks/useFooter';
import { useHeader } from '../../../hooks/useHeader';

export const Footer = () => {
  const { t, config, socialLinks } = useFooter();
  const { handleScrollToSection } = useHeader();

  return (
    <footer className={styles['footer']} id="contacto">
      <div className={styles['footer__wrap']}>

        <div className={styles['footer__top']}>
          <div className={styles['footer__brand']}>
            <img src={logo} alt="Bodhiwell" />
            <p>
              {t("landing.footer.description", "Bodhiwell integra salud, conciencia y comunidad para acompañar una nueva forma de comprender y buscar el bienestar humano.")}
            </p>
          </div>

          <div className={styles['footer__aside']}>
            <div className={styles['footer__nav-section']}>
              <h3>{t("landing.footer.quickLinksTitle", "Enlaces rápidos")}</h3>
              <Link to="/" onClick={handleScrollToSection('about')}>{t("landing.footer.quickLinks.about", "Acerca de")}</Link>
              <Link to="/" onClick={handleScrollToSection('how-it-works')}>{t("landing.header.howItWorks", "¿Cómo funciona?")}</Link>
              <Link to="/professionals">{t("landing.header.community", "Comunidad")}</Link>
              <a href={process.env.REACT_APP_BLOG_URL} target="_blank" rel="noopener noreferrer">
                {t("landing.footer.quickLinks.blog", "Blog")}
              </a>
              <Link to="/terms-conditions#terminos">{t("landing.footer.termsAndConditions", "Términos y condiciones")}</Link>
              <Link to="/privacy-policy#privacidad">{t("landing.footer.privacyPolicy", "Política de privacidad")}</Link>
              <Link to="/politica-de-cookies">{t("landing.footer.cookiesPolicy", "Política de cookies")}</Link>
            </div>

            <div className={styles['footer__nav-section']}>
              <h3>{t("landing.footer.followUsTitle", "Canales")}</h3>
              {socialLinks.map(({ id, label, url }) => (
                <a key={id} href={url} target="_blank" rel="noopener noreferrer">
                  {label}
                </a>
              ))}
              <a href={`mailto:${config.email}`}>{config.email}</a>
            </div>
          </div>
        </div>

        <div className={styles['footer__bottom']}>
          <div className={styles['footer__bottom_legal-section']}>
            <Link to="/terms-conditions#terminos">{t("landing.footer.termsAndConditions", "Términos y condiciones")}</Link>
            {' · '}
            <Link to="/privacy-policy#privacidad">{t("landing.footer.privacyPolicy", "Política de privacidad")}</Link>
            {' · '}
            <Link to="/politica-de-cookies">{t("landing.footer.cookiesPolicy", "Política de cookies")}</Link>
          </div>

          <div className={styles['footer__copy']}>
            © {config.currentYear} Bodhiwell®. Bodhiwell® es una marca registrada. {t("landing.footer.copyright", "Todos los derechos reservados.")}
          </div>
        </div>

      </div>
    </footer>
  );
};